import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import CONSTANTS from "../../../misc/constants";
import styled from "styled-components";

const About = () => {
  const lang = useSelector((store) => store.options.lang);

  useEffect(() => {
    document.title = `${CONSTANTS.APP_NAME} | About me`;
  }, []);

  return (
    <StyledAbout>
      <h1>{lang.data.about.title}</h1>
      <hr />
      <h2>Raúl Jesús Venegas Ugalde</h2>
      <div className="about cols col-2">
        <div className="col">
          <p>
            <i className="far fa-calendar-alt"></i> &nbsp;
            <strong>{lang.data.about.birthday}: </strong>
            01/08/1994
          </p>
          <p>
            <i className="fab fa-telegram"></i> &nbsp;
            <strong>Telegram: </strong>
            <a href="https://t.me/Xaek5" target="blank">
              @Xaek5
            </a>
          </p>
          <p>
            <i className="far fa-envelope"></i> &nbsp;
            <strong>Email: </strong>
            <a href="mailto:vuraul94@gmail.com" target="blank">
              vuraul94@gmail.com
            </a>
          </p>
          <p>
            <i className="fab fa-linkedin"></i>&nbsp;
            <strong>LinkedIn: </strong>
            <a href="https://www.linkedin.com/in/vuraul94/" target="blank">
              vuraul94
            </a>
          </p>
          <p>
            <i className="fab fa-twitter-square"></i>
            &nbsp;
            <strong>Twitter: </strong>
            <a href="https://twitter.com/Xaek_5" target="blank">
              @Xaek_5
            </a>
          </p>
          <p>
            <i className="fas fa-globe"></i> &nbsp;{" "}
            <strong>{lang.data.about.span}: </strong> {lang.data.about.span_lvl}
          </p>
          <p>
            <i className="fas fa-globe"></i> &nbsp;{" "}
            <strong>{lang.data.about.eng}: </strong> {lang.data.about.eng_lvl}
          </p>
        </div>
        <div className="col">
          <h3>{lang.data.about.title}</h3>
          <p>{lang.data.about.description}</p>
        </div>
      <hr />
        <div className="left">
          <h3>{lang.data.about.education}</h3>
          <h4>{lang.data.about.ucr}</h4>
          <ul>
            <li>{lang.data.about.bach_itm}</li>
            <li>{lang.data.about.lic_itm}</li>
          </ul>
        </div>
        <div className="right">
          <h3>{lang.data.about.work_exp}</h3>
          <h4>Leaf Music</h4>
          <ul>
            <li>{lang.data.about.leaf_job}</li>
          </ul>
        </div>
      <hr />
        <div className="skills center">
          <h3>{lang.data.about.skills}</h3>
          <div className="cols col-4">
            <div className="col">
              <h4>{lang.data.about.programming_langs}</h4>
              <ul>
                <li>
                  <i className="fas fa-crown"></i> Javascript
                </li>
                <li>
                  <i className="fas fa-circle"></i> C# (
                  {lang.data.about.for_unity})
                </li>
                <li>
                  <i className="fas fa-dot-circle"></i> PHP
                </li>
                <li>
                  <i className="far fa-circle"></i> Java
                </li>
                <li>
                  <i className="far fa-circle"></i> Python
                </li>
                <li>
                  <i className="far fa-circle"></i> Ruby
                </li>
              </ul>
            </div>
            <div className="col">
              <h4>{lang.data.about.tecnologies}</h4>
              <ul>
                <li>
                  <i className="fas fa-crown"></i> Node.js
                </li>
                <li>
                  <i className="fas fa-crown"></i> React
                </li>
                <li>
                  <i className="fas fa-crown"></i> Redux
                </li>
                <li>
                  <i className="fas fa-crown"></i> HTML
                </li>
                <li>
                  <i className="fas fa-crown"></i> CSS
                </li>
                <li>
                  <i className="fas fa-crown"></i> Aseprite
                </li>
                <li>
                  <i className="fas fa-circle"></i> Blender
                </li>
                <li>
                  <i className="fas fa-circle"></i> Inkscape
                </li>
                <li>
                  <i className="fas fa-circle"></i> GIMP
                </li>
                <li>
                  <i className="fas fa-dot-circle"></i> Wordpress
                </li>
                <li>
                <li>
                  <i className="far fa-circle"></i> Ruby on Rails
                </li>
                  <i className="far fa-circle"></i> Android Studio
                </li>
                <li>
                  <i className="far fa-circle"></i> Google Apps Script
                </li>
                <li>
                  <i className="far fa-circle"></i> Autodesk Maya
                </li>
                <li>
                  <i className="far fa-circle"></i> Autodesk Mudbox
                </li>
              </ul>
            </div>
            <div className="col">
              <h4>{lang.data.about.db}</h4>
              <ul>
                <li>
                  <i className="fas fa-crown"></i> Firebase (Realtime Database)
                </li>
                <li>
                  <i className="fas fa-circle"></i> Firebase (Firestore)
                </li>
                <li>
                  <i className="fas fa-dot-circle"></i> MongoDB
                </li>
                <li>
                  <i className="far fa-circle"></i> MySQL
                </li>
                <li>
                  <i className="far fa-circle"></i> Sqlite
                </li>
                <li>
                  <i className="far fa-circle"></i> Parse
                </li>
              </ul>
            </div>
            <div className="col">
              <h4>{lang.data.about.others}</h4>
              <ul>
                <li>
                  <i className="fas fa-crown"></i> {lang.data.about.agile}
                </li>
                <li>
                  <i className="fas fa-circle"></i> {lang.data.about.ux}
                </li>
                <li>
                  <i className="fas fa-circle"></i> {lang.data.about.model3d}
                </li>
                <li>
                  <i className="fas fa-circle"></i> Pixel Art
                </li>
                <li>
                  <i className="fas fa-dot-circle"></i> {lang.data.about.design}
                </li>
                <li>
                  <i className="fas fa-dot-circle"></i>{" "}
                  {lang.data.about.image_ed}
                </li>
                <li>
                  <i className="fas fa-dot-circle"></i>{" "}
                  {lang.data.about.video_ed}
                </li>
                <li>
                  <i className="far fa-circle"></i> {lang.data.about.animate3d}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="center">
          <h3>{lang.data.about.soft_skills}</h3>
          <p>{lang.data.about.soft_desc}</p>
        </div>
      </div>
      <hr />
      <div className="center">
        <h3>{lang.data.about.hobbies}</h3>
        <ul className="wrapped-list">
          <li>
            <i className="fas fa-star"></i> Pixel Art
          </li>
          <li>
            <i className="fas fa-star"></i> {lang.data.about.videogames}
          </li>
          <li>
            <i className="fas fa-star"></i> Anime
          </li>
          <li>
            <i className="fas fa-star"></i> {lang.data.about.read}
          </li>
          <li>
            <i className="fas fa-star"></i> {lang.data.about.write}
          </li>
          <li>
            <i className="fas fa-star"></i> {lang.data.about.agriculture}
          </li>
          <li>
            <i className="fas fa-star"></i> {lang.data.about.dialogue}
          </li>
        </ul>
      </div>
    </StyledAbout>
  );
};

const StyledAbout = styled.div`
  padding: 1rem;
  h3,
  h4 {
    margin: 0;
  }
  h3 {
    margin-top: 1rem;
  }

  .cols {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    @media (min-width: 1200px) {
      flex-direction: row;
    }
  }
  .col-2 {
    .col {
      @media (min-width: 1200px) {
        width: 48%;
      }
    }
  }

  .col-4 {
    .col {
      @media (min-width: 1200px) {
        width: 23%;
      }
    }
  }

  .left {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .right {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .center {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .wrapped-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    width: 100%;
    list-style: none;
    li {
      min-width: 23%;
      padding: 1rem;
      text-align: center;
    }
  }

  .skills {
    display: flex;
    flex-direction: column;
    align-items: center;
    h4 {
      text-align: center;
      margin-top: 1rem;
      height: 4rem;
    }
    ul {
      list-style: none;
    }
  }
  i {
    color: var(--mainColor);
  }
`;

export default About;
